import { ProjectPermissionDto } from 'shared/domain/user/types/inDto';
import { isVisibleNoAccess } from 'shared/domain/role/isVisibleNoAccess';

export function getAccessibleProjectIds(
  permissions: ProjectPermissionDto[]
): Set<string> {
  const ids = new Set<string>();
  for (const permission of permissions) {
    if (!isVisibleNoAccess(permission.role)) {
      ids.add(permission.project);
    }
  }
  return ids;
}

export function hasVisibleNoAccessRoleForProject(
  permissions: ProjectPermissionDto[],
  projectId: string
): boolean {
  return permissions.some(
    (permission) =>
      permission.project === projectId && isVisibleNoAccess(permission.role)
  );
}

function areAccessibleProjectSetsEqual(
  previous: Set<string>,
  current: Set<string>
): boolean {
  if (previous.size !== current.size) {
    return false;
  }
  for (const id of previous) {
    if (!current.has(id)) {
      return false;
    }
  }
  return true;
}

/**
 * Guard: has the set of accessible project IDs changed between permission snapshots.
 * First snapshot (previous undefined) is initialization, not a change.
 */
export function hasAccessibleProjectsChanged(
  previous: ProjectPermissionDto[] | undefined,
  current: ProjectPermissionDto[]
): boolean {
  if (!previous) {
    return false;
  }

  return !areAccessibleProjectSetsEqual(
    getAccessibleProjectIds(previous),
    getAccessibleProjectIds(current)
  );
}
